import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrReportKind.ts
var t = () => e("reportKind");
//#endregion
export { t as useTrReportKind };
